import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCircularProgress = styled(Box)(({ theme }) => ({
  '&&& .MuiCircularProgress-root': {
    color: theme.palette.generic.grey_600,
  },
}));
